module.exports = __webpack_public_path__ + "static/assets/b700cf6f9c368ce49851d287ddd3b63c.mp3";